var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 14.4286C5.04869 14.4286 5.86263 14.7597 6.46274 15.3491C7.06286 15.9385 7.4 16.7379 7.4 17.5714V19.1429H26.6V17.5714C26.6 16.7379 26.9371 15.9385 27.5373 15.3491C28.1374 14.7597 28.9513 14.4286 29.8 14.4286M4.2 14.4286C3.35131 14.4286 2.53737 14.7597 1.93726 15.3491C1.33714 15.9385 1 16.7379 1 17.5714V25.4286C1 25.8453 1.16857 26.245 1.46863 26.5397C1.76869 26.8344 2.17565 27 2.6 27H31.4C31.8243 27 32.2313 26.8344 32.5314 26.5397C32.8314 26.245 33 25.8453 33 25.4286V17.5714C33 16.7379 32.6629 15.9385 32.0627 15.3491C31.4626 14.7597 30.6487 14.4286 29.8 14.4286M4.2 14.4286V9.71429C4.2 8.46398 4.70571 7.26488 5.60589 6.38078C6.50606 5.49668 7.72696 5 9 5H25C26.273 5 27.4939 5.49668 28.3941 6.38078C29.2943 7.26488 29.8 8.46398 29.8 9.71429V14.4286M17 5V19.1429",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingRoom);
export default __webpack_public_path__ + "static/media/living_room.3fcbec9b814ef07da281f9975f80806c.svg";
export { ForwardRef as ReactComponent };